import React from "react";
import { createPortal } from "../../windowManager/browserFenster/fensterPortal";

/** Sekunden bis zur Aufnahme — Zeit, um ein Menü, eine Auswahlliste oder einen Tooltip zu öffnen. */
export const SELBSTAUSLOESER_SEKUNDEN = 5;

type Props = { sekunden?: number; onAusloesen: () => void; onAbbruch: () => void };

/**
 * Selbstauslöser für „Bereich fotografieren“: Ein Klick auf den Melden-Knopf
 * schließt jedes offene Menü (Klick außerhalb). Deshalb läuft hier ein Zähler,
 * während die Seite voll bedienbar bleibt — nur die kleine Anzeige unten rechts
 * fängt Klicks, sie trägt `data-ticket-ignore` und ist im Bild nicht zu sehen.
 * Bewusst KEIN Escape-Handler und kein Fokus: Beides bräuchte das Menü selbst.
 */
export function Selbstausloeser({ sekunden = SELBSTAUSLOESER_SEKUNDEN, onAusloesen, onAbbruch }: Props) {
  const [rest, setRest] = React.useState(sekunden);
  const ausloesenRef = React.useRef(onAusloesen);
  React.useEffect(() => { ausloesenRef.current = onAusloesen; });

  React.useEffect(() => {
    const t = window.setInterval(() => setRest((r) => r - 1), 1000);
    return () => window.clearInterval(t);
  }, []);
  React.useEffect(() => {
    if (rest <= 0) ausloesenRef.current();
  }, [rest]);

  return createPortal(
    <div className="kvp-rd tk-ausloeser" data-ticket-ignore role="status" aria-live="polite">
      <span className="tk-ausloeser-zahl" aria-label={`Aufnahme in ${Math.max(rest, 0)} Sekunden`}>{Math.max(rest, 0)}</span>
      <span className="tk-ausloeser-text">Jetzt das Menü öffnen, dann wird fotografiert</span>
      <button type="button" className="tp-detail-btn" onClick={onAbbruch}>Abbrechen</button>
    </div>,
    document.body,
  );
}
